import axios, { type AxiosError } from 'axios'

export const apiClient = axios.create({
  baseURL: '/',
  withCredentials: true,
  timeout: 120_000,
})

export function apiErrorMessage(err: unknown): string {
  const ax = err as AxiosError<{ detail?: unknown; error?: string }>
  const data = ax?.response?.data as { detail?: unknown; error?: string } | undefined
  if (data?.detail) {
    if (typeof data.detail === 'string') return data.detail
    if (Array.isArray(data.detail)) {
      return data.detail
        .map((d: unknown) => {
          const e = d as { msg?: string; loc?: string[] }
          return e?.msg ?? JSON.stringify(e)
        })
        .join('; ')
    }
    if (typeof data.detail === 'object' && data.detail && 'error' in (data.detail as object)) {
      return String((data.detail as { error?: string }).error ?? 'Error')
    }
    return JSON.stringify(data.detail)
  }
  if (data?.error) return data.error
  return ax?.message ?? 'Request failed'
}
